import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatterStatus, matterStatusLabels } from '@models/matter';
import { TestHooks } from './matter-status-tile.hooks';

export const matterStatusColorClass: { [key in MatterStatus]: string } = {
	[MatterStatus.ACTIVE]: 'bg-green-light',
	[MatterStatus.CLOSED]: 'bg-blue-highlight',
	[MatterStatus.INACTIVE]: 'bg-grey-light',
};

@Component({
	selector: 'app-matter-status-tile',
	templateUrl: './matter-status-tile.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class MatterStatusTileComponent {
	testHooks = TestHooks;
	matterStatusColorClass = matterStatusColorClass;
	matterStatusLabels = matterStatusLabels;
	@Input() status: MatterStatus;
}
